import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import type { Resource } from 'i18next';

import { CLIENT_APP_LOCALES_LIST } from '@/constants';

export function initI18n(resources: Resource = {}, lng?: string): void {
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      lng,
      resources,
      supportedLngs: CLIENT_APP_LOCALES_LIST,
      interpolation: {
        escapeValue: false,
      },
    });
}

export function transformLocales(
  locales: Array<Record<string, Record<string, string>> | undefined>,
  availableLocales: string[],
): Record<string, { translation: Record<string, string> }> {
  return availableLocales.reduce(
    function (res, lang) {
      const translations = locales.reduce(
        function (translation, locale = {}) {
          return { ...translation, ...locale[lang] };
        },
        {} as Record<string, string>,
      );
      return { ...res, [lang]: { translation: translations } };
    },
    {} as Record<string, { translation: Record<string, string> }>,
  );
}
